module.exports = __webpack_public_path__ + "static/media/info-traingle-warning.8f5257fa.svg";